import { useEffect } from 'react';

function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | Australia College` : 'Australia College';

    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', 'description');
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', description);
    }
  }, [title, description]);
}

export default usePageMeta;
